import { getBondFormKindConfig } from "../../shared/bondFormConfig";
import useBondFormBase, { createBondKindLogic } from "../../shared/hooks/useBondFormBase";

const config = getBondFormKindConfig("guardianship");

export default function useGuardianshipBondForm() {
  return useBondFormBase({
    config,
    logContext: "useGuardianshipBondForm",
    useBondKindLogic: createBondKindLogic(config),
  });
}
